import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ltcs-duplicate-dialog" }
const _hoisted_2 = { class: "ltcs-duplicate-dialog__header" }
const _hoisted_3 = { class: "header-title-wrap" }
const _hoisted_4 = { class: "ltcs-duplicate-dialog__body" }
const _hoisted_5 = {
  key: 0,
  class: "duplicate-summary-bar"
}
const _hoisted_6 = {
  key: 0,
  class: "duplicate-hint duplicate-hint--claim"
}
const _hoisted_7 = {
  key: 1,
  class: "duplicate-hint"
}
const _hoisted_8 = {
  key: 1,
  class: "duplicate-empty"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "group-label" }
const _hoisted_11 = { class: "group-count" }
const _hoisted_12 = {
  key: 0,
  class: "duplicate-group__table-wrap"
}
const _hoisted_13 = { class: "duplicate-group__table" }
const _hoisted_14 = { class: "idx-cell" }
const _hoisted_15 = { class: "ltcs-duplicate-dialog__footer" }

import { computed, ref, watch } from 'vue';
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';

export interface LtcsDuplicateGroup {
  groupKey: string;
  count: number;
  label: string;
  rows: Record<string, unknown>[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LtcsDuplicateDialog',
  props: {
    modelValue: { type: Boolean },
    loading: { type: Boolean, default: false },
    duplicateCount: { default: 0 },
    duplicateGroupCount: { default: 0 },
    groups: { default: () => [] },
    tableHeaders: { default: () => [] },
    idxKey: { default: 'idx' },
    sourceType: { default: '' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isClaimDetail = computed(
  () => props.sourceType === 'caion_ltcs_claim_detail'
);

const expandedKeys = ref(new Set<string>());

const displayColumns = computed(() => {
  if (props.tableHeaders.length <= 6) return props.tableHeaders;
  return props.tableHeaders.slice(0, 8);
});

const toggleGroup = (key: string) => {
  const next = new Set(expandedKeys.value);
  if (next.has(key)) next.delete(key);
  else next.add(key);
  expandedKeys.value = next;
};

const scrollToFirstGroup = () => {
  if (props.groups.length > 0) {
    expandedKeys.value = new Set([props.groups[0].groupKey]);
  }
};

const formatCell = (val: unknown, key: string) => {
  if (val == null || val === '') return '-';
  if (typeof key === 'string' && (key.endsWith('_date') || key.endsWith('_birth'))) {
    const d = new Date(String(val));
    if (!Number.isNaN(d.getTime())) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    }
  }
  if (typeof key === 'string' && key.endsWith('_time')) {
    return String(val).substring(0, 5);
  }
  return String(val);
};

watch(
  () => props.modelValue,
  (open) => {
    if (open && props.groups.length > 0) {
      expandedKeys.value = new Set([props.groups[0].groupKey]);
    } else if (!open) {
      expandedKeys.value = new Set();
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": __props.modelValue,
    "max-width": "960",
    scrollable: "",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_icon, {
              size: "18",
              color: "#c62828"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("mdi-content-duplicate", -1)
              ]))]),
              _: 1
            }),
            _cache[4] || (_cache[4] = _createElementVNode("h3", null, "중복 데이터 상세", -1))
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "close-btn",
            "aria-label": "닫기",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', false)))
          }, [
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("mdi-close", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(LoadingOverlay, {
            show: __props.loading,
            text: "중복 데이터 불러오는 중..."
          }, null, 8, ["show"]),
          (!__props.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(isClaimDetail.value ? '같은 방문이 여러 줄' : '동일 키 기준 중복') + " ", 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "duplicate-count-link",
                    onClick: scrollToFirstGroup
                  }, _toDisplayString(__props.duplicateCount.toLocaleString()) + "건 ", 1),
                  _createTextVNode(" (" + _toDisplayString(__props.duplicateGroupCount.toLocaleString()) + "개 그룹) ", 1)
                ]),
                (isClaimDetail.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, " 청구의뢰와 지급이 같이 있는 방문은 여기 나오지 않습니다. 아래는 같은 방문이 같은 처리상태로 여러 줄인 경우입니다. "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, "아래 그룹별로 중복된 행을 확인할 수 있습니다."))
              ]))
            : _createCommentVNode("", true),
          (!__props.loading && __props.groups.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(isClaimDetail.value ? '같은 방문이 여러 줄인 중복은 없습니다.' : '중복 데이터가 없습니다.'), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.groups, (group, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: group.groupKey,
              class: "duplicate-group"
            }, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["duplicate-group__toggle", { open: expandedKeys.value.has(group.groupKey) }]),
                onClick: ($event: any) => (toggleGroup(group.groupKey))
              }, [
                _createVNode(_component_v_icon, { size: "16" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(expandedKeys.value.has(group.groupKey) ? 'mdi-chevron-down' : 'mdi-chevron-right'), 1)
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("span", _hoisted_10, _toDisplayString(group.label), 1),
                _createElementVNode("span", _hoisted_11, _toDisplayString(group.count) + "건", 1)
              ], 10, _hoisted_9),
              (expandedKeys.value.has(group.groupKey))
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("table", _hoisted_13, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _cache[6] || (_cache[6] = _createElementVNode("th", null, "번호", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayColumns.value, (col) => {
                            return (_openBlock(), _createElementBlock("th", {
                              key: col.key
                            }, _toDisplayString(col.title), 1))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.rows, (row) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: row[__props.idxKey]
                          }, [
                            _createElementVNode("td", _hoisted_14, _toDisplayString(row[__props.idxKey]), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayColumns.value, (col) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: col.key
                              }, _toDisplayString(formatCell(row[col.key], col.key)), 1))
                            }), 128))
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _createElementVNode("footer", _hoisted_15, [
          _createVNode(_component_v_btn, {
            variant: "text",
            class: "btn-close",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('update:modelValue', false)))
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("닫기", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})